export const FILTER_COLOR_PALETTE = [
  "#0f766e",
  "#2563eb",
  "#d97706",
  "#be123c",
  "#7c3aed",
  "#0891b2",
  "#28785e",
  "#ea580c",
  "#c026d3",
  "#64748b",
] as const;

const MANUFACTURER_COLOR_OVERRIDES: Record<string, string> = {
  KELIT: "#0f766e",
  HANSGROHE: "#4e79a7",
  GROHE: "#e15759",
  GEBERIT: "#59a14f",
  VIEGA: "#f28e2b",
  VONOVA: "#d97706",
  VOVONA: "#d97706",
  ALVA: "#be123c",
  DANFOSS: "#7c3aed",
  DURAVIT: "#0891b2",
  JUDO: "#28785e",
  "FISCHER GEORG": "#2563eb",
  FISCHER: "#2563eb",
  OVENTROP: "#d97706",
  ZEHNDER: "#0f766e",
  POLOPLAST: "#64748b",
  NOVELLINI: "#0891b2",
  PROTHERM: "#7c3aed",
};

const SUPPLIER_COLOR_OVERRIDES: Record<string, string> = {
  SHT: "#004088",
  GC: "#cc0935",
};

function hashKey(key: string): number {
  let hash = 0;
  for (let index = 0; index < key.length; index += 1) {
    hash = (hash * 31 + key.charCodeAt(index)) >>> 0;
  }
  return hash;
}

export function filterColor(kind: "manufacturer" | "supplier", key: string) {
  const normalized = key.trim().toUpperCase();
  if (kind === "manufacturer" && MANUFACTURER_COLOR_OVERRIDES[normalized]) {
    return MANUFACTURER_COLOR_OVERRIDES[normalized];
  }
  if (kind === "supplier" && SUPPLIER_COLOR_OVERRIDES[normalized]) {
    return SUPPLIER_COLOR_OVERRIDES[normalized];
  }
  return FILTER_COLOR_PALETTE[
    hashKey(`${kind}:${normalized}`) % FILTER_COLOR_PALETTE.length
  ];
}

export const REST_SLICE_COLOR = "#cbd5e1";
